<div class="pdf-container">
  <iframe
    [src]="pdfUrl"
    width="100%"
    height="100%"
    style="border:none;"
  ></iframe>
</div>
